import React from 'react';
import Card from '../../components/card';
import { DollarTextField } from '../../components/MaskedTextField';
import style from '../../styles/form';
import { BorrowerCard, CoborrowerCard } from '../card-lenses';

const validateCash = (num) =>
  num != undefined && num !== '' ? '' : 'Please enter a dollar amount';

const Commission = ({ model, onChange, id, ...cardProps }) => (
  <Card
    title={`About how much commission income did ${id === 'borrower' ? 'you' : 'they'} receive in:`}
    {...cardProps}
  >
    <p>Please estimate within a few thousand dollars</p>
    <DollarTextField
      value={model.get('lastYearCommission')}
      onChange={onChange.bind(null, 'lastYearCommission')}
      style={style.threeQuarters}
      floatingLabelText={'Past 12 months commission'}
      hintText="$/Year"
      validate={validateCash}
    />

    <DollarTextField
      value={model.get('twoYearOldCommission')}
      onChange={onChange.bind(null, 'twoYearOldCommission')}
      style={style.threeQuarters}
      floatingLabelText={'Previous year commission (12-24 months ago)'}
      hintText="$/Year"
      validate={validateCash}
    />
  </Card>
);

Commission.id = 'Commission';

Commission.completed = ({ model }) =>
  !(
    validateCash(model.get('lastYearCommission')) || validateCash(model.get('twoYearOldCommission'))
  );

export const PrimaryBorrowerCommission = BorrowerCard(Commission, 'PrimaryBorrowerCommission', {
  id: 'borrower'
});

export const CoborrowerCommission = CoborrowerCard(Commission, 'CoborrowerCommission', {
  id: 'coborrower'
});



// WEBPACK FOOTER //
// ./src/cards/bonus-cards/commission.js